import { message } from 'antd';
import { config } from 'util/config';
import { httpClient } from "util/Api";
import * as globalFunction from 'util/GlobalFunction';

// 顶部 Certificate 筛选变更后，将值带入列表查询参数并刷新当前 Job 的证书列表。
export function getSectionDataByDefault({ parameter, sectionComponent, uie } = {}) {
  const componentDefaultValue = { ...sectionComponent.state.componentDefaultValue, [uie.source]: parameter };
  const searchParameter = { ...sectionComponent.props.searchParameter, ...sectionComponent.state.searchParameter, [uie.source]: parameter };
  sectionComponent.setState({ componentDefaultValue, searchParameter }, () => sectionComponent.getSectionDataByDefault());
}

export function addFromTemplate({ sectionName, parameter, sectionComponent, pageComponent, uie } = {}) {
  openAddFromTemplate({ component: pageComponent });
}

export function licenceRegistrationValidationQBCC({ pageComponent } = {}) {
  pageComponent.setState({ licenceRegistrationValidationShow: true }, () => {
    pageComponent.licenceRegistrationValidation.current?.runValidation('QBCC');
  });
}

export function openAddFromTemplate({ component } = {}) {
  component.setState({ jobRequiredCertificateAddFromTemplateShow: true });
  component.jobRequiredCertificateAddFromTemplate.current?.setState({ activeKey: 0 });
  setTimeout(() => {
    component.jobRequiredCertificateAddFromTemplate.current?.formRef.current?.resetFields();
    component.jobRequiredCertificateAddFromTemplate.current?.additionalFormRef.current?.child.current?.setState({ defaultSelectedRowKeys: [], requiredCertificateTemplatePresetContentList: [] });
    setTimeout(() => {
      component.jobRequiredCertificateAddFromTemplate.current?.additionalFormRef.current?.child.current?.getRequiredCertificateTemplateData();
      component.jobRequiredCertificateAddFromTemplate.current?.getRequiredCertificateTemplatePresetDataSource();
      console.log(component.jobRequiredCertificateAddFromTemplate.current?.additionalFormRef.current?.child.current)
    }, config.setTimeoutMilliSecond);
  }, config.setTimeoutMilliSecond);
}

export function batchDelete({ sectionName, parameter, formComponent, sectionComponent, pageComponent, uie } = {}) {
  if (sectionComponent.child.current?.state.selectedRowKeys.length !== 0) {
    globalFunction.confirm({
      content: 'Do you want to delete these records?',
      okText: 'Delete',
      okType: 'danger',
      callback: function () {
        httpClient
          .post('Business/JobRequiredCertificate/BatchDelete', sectionComponent.child.current?.state.selectedRowKeys)
          .then(({ data }) => {
            if (data.result) {
              sectionComponent.child.current?.setState({ selectedRowKeys: [] });
              setTimeout(() => {
                sectionComponent.child.current?.getSectionDataByDefault();
              }, config.setTimeoutMilliSecond);
            } else {
              globalFunction.handleResultError(data, pageComponent);
            }
          })
          .catch(function (error) {
            globalFunction.handleError(error, pageComponent);
          });
      }
    });
  } else {
    message.warning('You must select at least one item.');
  }
}

export function batchUpdateDateReceived({ sectionName, parameter, formComponent, sectionComponent, pageComponent, uie } = {}) {
  if (sectionComponent.child.current?.state.selectedRowKeys.length !== 0) {
    pageComponent.setState({ jobRequiredCertificateBatchUpdateDateReceivedShow: true });
  } else {
    message.warning('You must select at least one item.');
  }
}

//弹出mailmerge的div
export function docMergeJobRequiredCertificate({ sectionName, parameter, formComponent, sectionComponent, pageComponent, uie } = {}) {
  pageComponent.setState({ mailMergeTemplateShow: true, mailMergeObjId: parameter.JobRequiredCertificateId, mailMergeObj: parameter, dataModelType: 9 });
  setTimeout(() => {
    pageComponent.mailMergeTemplate.current?.getMailMergeTemplate(9, parameter.JobRequiredCertificateId);
  }, config.setTimeoutMilliSecond);
}
